module.exports = __webpack_public_path__ + "img/微信.bbb213b8.png";